import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FortIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fort"}/>
}
